import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowRightUpCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-right-up-circle"} maskId="square-filled-radius-0-stroke-1-IconArrowRightUpCircle"><path fillRule="evenodd" clipRule="evenodd" d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12ZM16 8H9V9H14.2929L7.79289 15.5L8.5 16.2071L15 9.70711V15H16V8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowRightUpCircle;
